import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.hospital;

export const getHospitalPlansSelector = createSelector(getState, (state) => state.hospitalPlans);
